import { gql } from '@apollo/client'

export const BUSINESS_PROCESSES_TREE_QUERY = gql`
  query BUSINESS_PROCESSES_TREE_QUERY($pagination: PaginationInput, $filter: BusinessProcessFilterInput) {
    businessProcesses(pagination: $pagination, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        code
        active
        expanded
        parentId
        description
        createdAt
        position
        parent {
          id
          description
        }
      }
    }
  }
`

export const BUSINESS_PROCESSES_SELECT_QUERY = gql`
  query BUSINESS_PROCESSES_SELECT_QUERY($filter: BusinessProcessFilterInput) {
    businessProcesses(filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        active
        description
        parent {
          id
          description
        }
      }
    }
  }
`
